import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Target, ShieldCheck, CreditCard } from 'lucide-react';
export function Hero() {
  const badges = [{
    icon: <FileText size={16} data-id="element-133" />,
    text: 'PDF descargable'
  }, {
    icon: <Zap size={16} data-id="element-134" />,
    text: 'Acceso inmediato'
  }];
  return <section className="relative pt-3 pb-6 px-3 md:pt-4 md:pb-10 max-w-5xl mx-auto text-center overflow-hidden" data-id="element-135">
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(120,180,30,0.2) 0%, rgba(168,216,48,0.06) 40%, transparent 70%)'
    }} data-id="element-136" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} data-id="element-137">
        <span className="inline-block py-0.5 px-2.5 rounded-full bg-accent/10 text-accent font-semibold text-xs mb-2 tracking-wide uppercase" data-id="element-138">
          🍃Salud en tu plato
        </span>

        <h1 className="md:text-5xl lg:text-6xl mb-2 font-[900] font-['Open_Sans',_sans-serif] text-white text-[32px]" data-id="element-139">
          Dominá la nutrición deportiva
        </h1>

        <div className="mb-2 flex justify-center" data-id="element-140">
          <img src="https://cdn.magicpatterns.com/uploads/gyBESxmba2JvSs7mpyavU5/5e344a59-f7fe-4fcf-b14c-f6590cb7b15f.png" alt="Megapack Nutri Deportiva — Kit Profesional para Nutricionistas" className="w-full max-w-[420px] md:max-w-lg drop-shadow-2xl pl-[80px] pr-[80px]" data-id="element-141" />
        </div>

        <p className="md:text-2xl italic text-accent/80 mb-2 max-w-3xl mx-auto text-[15px] font-[800] font-[Avenir,_sans-serif]" data-id="element-142">
          Listo para implementar. Sin pérdida de tiempo. Sin improvisación. Sin
          comprometer tu descanso.
        </p>

        <p className="text-white/60 max-w-2xl mx-auto mb-3 text-[14px]" data-id="element-143">
          El sistema para nutrición deportiva: consulta + planificación +
          protocolos + seguimiento + criterio clínico, listo para aplicar desde
          hoy.
        </p>

        <div className="flex flex-wrap justify-center gap-1.5 mb-3 max-w-3xl mx-auto" data-id="element-144">
          {badges.map((badge, idx) => <div key={idx} className="flex items-center gap-1.5 bg-surface border border-accent/10 px-2.5 py-1 rounded-md text-xs text-white/80 font-medium shadow-sm" data-id="element-145">
              <span className="text-accent" data-id="element-146">{badge.icon}</span>
              {badge.text}
            </div>)}
        </div>

        <motion.a href="#comprar" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="inline-block bg-accent hover:bg-accent/80 text-black font-bold md:text-lg py-2.5 px-5 md:px-8 rounded-xl shadow-lg shadow-accent/20 transition-colors text-[18px]" data-id="element-147">
          🧠 QUIERO MI MEGAPACK NUTRI DEPORTIVA AHORA
        </motion.a>

        <div className="flex flex-wrap justify-center gap-3 mt-3" data-id="element-148">
          <div className="flex items-center gap-1.5 text-white/50 text-sm font-medium" data-id="element-149">
            <Target size={16} className="text-accent" data-id="element-150" />
            Enfoque consulta real
          </div>
          <div className="flex items-center gap-1.5 text-white/50 text-sm font-medium" data-id="element-151">
            <ShieldCheck size={16} className="text-accent" data-id="element-152" />
            Pago seguro
          </div>
          <div className="flex items-center gap-1.5 text-white/50 text-sm font-medium" data-id="element-153">
            <CreditCard size={16} className="text-accent" data-id="element-154" />
            Mercado Pago
          </div>
        </div>
      </motion.div>
    </section>;
}